import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// IMDG CODE(海运危险货物规则)

export function getIMDGCodeByUNNo(params) {
  return request({
    url: URL.sys.queryImdgCodeByUnNo,
    method: 'get',
    params
  })
}

export function getIMDGClassification(params) {
  return request({
    url: URL.sys.getIMDGClassification,
    method: 'get',
    params
  })
}

// 分页查询危险品列表
export function queryIMDGCodes(data) {
  return request({
    url: URL.sys.queryIMDGCodes,
    method: 'post',
    data
  })
}

// 查询单条危险品
export function queryIMDGCodeByUuid(params) {
  return request({
    url: URL.sys.queryIMDGCodeByUuid,
    method: 'post',
    params
  })
}

// 批量删除危险品
export function removeIMDGCodes(data) {
  return request({
    url: URL.sys.removeIMDGCodes,
    method: 'post',
    data
  })
}

// 编号是否重复
export function isUniqueUnNo(params) {
  return request({
    url: URL.sys.isUniqueUnNo,
    method: 'post',
    params
  })
}

// 保存危险品编号
export function saveIMDGCode(data) {
  return request({
    url: URL.sys.saveIMDGCode,
    method: 'post',
    data
  })
}
